import { GetServerSidePropsContext } from 'next';
import {
  ExperienceCalculatePricingResponse,
  ExperienceSessionCalculatePricingPayload,
  ExperienceSessionGetParams,
} from 'types/experience/experience-session.type';
import { client } from 'utils/axios';
import { ssrRequest } from 'utils/ssrRequestFactory';
import qs from 'qs';

class ExperienceService {
  getExperienceSSR(ctx: GetServerSidePropsContext) {
    const splittedUrl = (ctx.params?.slug as string).split('-');
    const experienceId = splittedUrl[splittedUrl.length - 1];
    const sessionId = ctx.query['sessionId'];
    return ssrRequest(`/v1/customer/experience/${experienceId}`, ctx, {
      params: {
        sessionId,
      },
    });
  }

  async getExperienceSessions(
    experienceId: number,
    params: ExperienceSessionGetParams
  ) {
    const query = {
      pagination: {
        page: 0,
        size: 270,
        sort: 'dateTimeRange.startTime,asc',
      },
      ...params,
    };
    const paramsQs = qs.stringify(query, {
      allowDots: true,
      arrayFormat: 'repeat',
    });
    const { data } = await client.get(
      `/v1/customer/experience/${experienceId}/sessions?${paramsQs}`
    );
    return data;
  }

  async calculateExperiencePricing(
    body: ExperienceSessionCalculatePricingPayload
  ): Promise<ExperienceCalculatePricingResponse> {
    const { data } = await client.post(
      `/v1/customer/experience/calculate-pricing`,
      body
    );
    return data;
  }
}

export const experienceService = new ExperienceService();
